import { Tab } from "@headlessui/react";
import { groupBy } from "lodash";
import { TabNoData } from "../components/common/NoData";

import TextNavBackground from "../components/common/TextNavBackground";
import { apiWrapper } from "../utils/api/apiWrapper";
import { kAllFixturesURL } from "../utils/constants/apiUrls";
import { ONE_DAY_REFRESH_INTERVAL_SECONDS } from "../utils/constants/numbers";
import { convertToMonth } from "../utils/helpers/dateAndTime";
import { customStaticSeoConfig, getApiToken } from "../utils/helpers/helpers";

import LastMatchBanner from "../components/elements/fixtures/LastMatchBanner";
import NextMatchBanner from "../components/elements/fixtures/NextMatchBanner";
import FixtureCard from "../components/elements/fixtures/FixtureCard";
import FixtureResultCard from "../components/elements/fixtures/FixtureResultCard";
import StandingsButton from "../components/elements/fixtures/StandingsButton";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const FixturesAndResults = ({ fixturesAndResults }) => {
  const {
    season_title: seasonTitle,
    data: result,
    ticket_website_url,
    membership_website_url,
    kotoko_tv_url,
  } = fixturesAndResults;
  const { ticket_website_url: ticketUrl } = ticket_website_url;
  const { membership_website_url: membershipUrl } = membership_website_url;
  const { live_tv_url: liveTvUrl } = kotoko_tv_url;

  const {
    academy_fixtures: academyFixtures,
    men_fixtures: menFixtures,
    women_fixtures: womenFixtures,
  } = result;

  const {
    academy_results: academyResults,
    men_results: menResults,
    women_results: womenResults,
  } = result;

  const menLastMatch = menResults[0];
  const menNextMatch = menFixtures[0];

  const womenLastMatch = womenResults[0];
  const womenNextMatch = womenFixtures[0];

  const academyLastMatch = academyResults[0];
  const academyNextMatch = academyFixtures[0];

  // Group fixtures and results into months and ignore the first fixture and
  // results in the array since we are showing it on the last and next match banners

  // GROUPED MEN
  const groupedMenFixtures = groupBy(menFixtures.slice(1), (item) =>
    convertToMonth(item),
  );

  const groupedMenResults = groupBy(menResults.slice(1), (item) =>
    convertToMonth(item),
  );

  // GROUPED WOMEN
  const groupedWomenFixtures = groupBy(womenFixtures.slice(1), (item) =>
    convertToMonth(item),
  );

  const groupedWomenResults = groupBy(womenResults.slice(1), (item) =>
    convertToMonth(item),
  );

  // GROUPED ACADEMY
  const groupedAcademyFixtures = groupBy(academyFixtures.slice(1), (item) =>
    convertToMonth(item),
  );

  const groupedAcademyResults = groupBy(academyResults.slice(1), (item) =>
    convertToMonth(item),
  );

  return (
    <>
      {customStaticSeoConfig(`${seasonTitle} Fixtures &  Results`)}
      <TextNavBackground title={`${seasonTitle} Fixtures &  Results`} />

      <div className="block w-full text-base sm:text-sm">
        <Tab.Group>
          <Tab.List className="-mb-px flex justify-center items-center space-x-8 overflow-x-auto bg-gray-200">
            {/* <Tab
              className={({ selected }) =>
                classNames(
                  "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none",
                  selected
                    ? "border-red-500 dark:border-green-500 text-red-600 dark:text-green-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 active:border-none"
                )
              }
            >
              Men
            </Tab> */}
            {/* <Tab
              className={({ selected }) =>
                classNames(
                  "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none",
                  selected
                    ? "border-red-500 dark:border-green-500 text-red-600 dark:text-green-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 active:border-none"
                )
              }
            >
              Women
            </Tab>
            <Tab
              className={({ selected }) =>
                classNames(
                  "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none",
                  selected
                    ? "border-red-500 dark:border-green-500 text-red-600 dark:text-green-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 active:border-none"
                )
              }
            >
              Academy
            </Tab> */}
          </Tab.List>
          <Tab.Panels>
            {/* MEN FIXTURES AND RESULTS */}
            <Tab.Panel className="mt-5">
              {menFixtures.length !== 0 || menResults.length !== 0 ? (
                <Tab.Group>
                  <Tab.List className="-mb-px flex justify-center items-center space-x-8 overflow-x-auto">
                    <Tab
                      className={({ selected }) =>
                        classNames(
                          "whitespace-nowrap px-3 py-2 font-medium text-sm rounded-md focus:outline-none mb-6",
                          selected
                            ? "bg-red-100 text-red-700 dark:bg-green-100 dark:text-green-700 active:border-none"
                            : "text-gray-500 hover:text-gray-700",
                        )
                      }
                    >
                      Fixtures
                    </Tab>
                    <Tab
                      className={({ selected }) =>
                        classNames(
                          "whitespace-nowrap px-3 py-2 font-medium text-sm rounded-md focus:outline-none mb-6",
                          selected
                            ? "bg-red-100 text-red-700 dark:bg-green-100 dark:text-green-700 active:border-none"
                            : "text-gray-500 hover:text-gray-700",
                        )
                      }
                    >
                      Results
                    </Tab>
                  </Tab.List>
                  <Tab.Panels>
                    <Tab.Panel>
                      <div className="mb-16">
                        <>
                          {menNextMatch ? (
                            <NextMatchBanner fixture={menNextMatch} />
                          ) : (
                            <></>
                          )}
                        </>

                        {Object.keys(groupedMenFixtures).length !== 0 ? (
                          Object.keys(groupedMenFixtures).map(
                            (month, index) => {
                              return (
                                <>
                                  <div key={index}>
                                    <h2 className="text-lg font-extrabold tracking-tight text-gray-400 text-center mt-20">
                                      {month}
                                    </h2>
                                    {groupedMenFixtures[month].map(
                                      (fixture) => {
                                        return (
                                          <div
                                            key={fixture.id}
                                            className="mb-6"
                                          >
                                            <FixtureCard
                                              fixture={fixture}
                                              ticketUrl={ticketUrl}
                                            />
                                          </div>
                                        );
                                      },
                                    )}
                                  </div>
                                </>
                              );
                            },
                          )
                        ) : (
                          <TabNoData />
                        )}
                      </div>
                    </Tab.Panel>
                    <Tab.Panel>
                      <div className="mb-16">
                        {menLastMatch ? (
                          <>
                            <LastMatchBanner fixture={menLastMatch} />

                            <StandingsButton />
                          </>
                        ) : (
                          <></>
                        )}

                        {Object.keys(groupedMenResults).length !== 0 ? (
                          Object.keys(groupedMenResults).map((month, index) => {
                            return (
                              <>
                                <div key={index}>
                                  <h2 className="text-lg font-extrabold tracking-tight text-gray-400 text-center mt-20">
                                    {month}
                                  </h2>
                                  {groupedMenResults[month].map((result) => {
                                    return (
                                      <div key={result.id} className="mb-6">
                                        <FixtureResultCard result={result} />
                                      </div>
                                    );
                                  })}
                                </div>
                              </>
                            );
                          })
                        ) : (
                          <TabNoData />
                        )}
                      </div>
                    </Tab.Panel>
                  </Tab.Panels>
                </Tab.Group>
              ) : (
                <TabNoData />
              )}
            </Tab.Panel>

            {/* WOMEN FIXTURES AND RESULTS */}
            {/* <Tab.Panel className="mt-5">
              {womenFixtures.length !== 0 || womenResults.length !== 0 ? (
                <Tab.Group>
                  <Tab.List className="-mb-px flex justify-center items-center space-x-8 overflow-x-auto">
                    <Tab
                      className={({ selected }) =>
                        classNames(
                          "whitespace-nowrap px-3 py-2 font-medium text-sm rounded-md focus:outline-none mb-6",
                          selected
                            ? "bg-red-100 text-red-700 dark:bg-green-100 dark:text-green-700 active:border-none"
                            : "text-gray-500 hover:text-gray-700"
                        )
                      }
                    >
                      Fixtures
                    </Tab>
                    <Tab
                      className={({ selected }) =>
                        classNames(
                          "whitespace-nowrap px-3 py-2 font-medium text-sm rounded-md focus:outline-none mb-6",
                          selected
                            ? "bg-red-100 text-red-700 dark:bg-green-100 dark:text-green-700 active:border-none"
                            : "text-gray-500 hover:text-gray-700"
                        )
                      }
                    >
                      Results
                    </Tab>
                  </Tab.List>
                  <Tab.Panels>
                    <Tab.Panel>
                      <div className="mb-16">
                        {womenNextMatch ? (
                          <NextMatchBanner fixture={womenNextMatch} />
                        ) : (
                          <></>
                        )}

                        {Object.keys(groupedWomenFixtures).length !== 0 ? (
                          Object.keys(groupedWomenFixtures).map(
                            (month, index) => {
                              return (
                                <>
                                  <div key={month}>
                                    <h2 className="text-lg font-extrabold tracking-tight text-gray-400 text-center mt-20">
                                      {month}
                                    </h2>
                                    {groupedWomenFixtures[month].map(
                                      (fixture) => {
                                        return (
                                          <div
                                            key={fixture.id}
                                            className="mb-6"
                                          >
                                            <FixtureCard
                                              fixture={fixture}
                                              ticketUrl={ticketUrl}
                                            />
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                </>
                              );
                            }
                          )
                        ) : (
                          <TabNoData />
                        )}
                      </div>
                    </Tab.Panel>
                    <Tab.Panel>
                      <div className="mb-16">
                        {womenLastMatch ? (
                          <>
                            <LastMatchBanner fixture={womenLastMatch} />

                            <StandingsButton />
                          </>
                        ) : (
                          <></>
                        )}

                        {Object.keys(groupedWomenResults).length !== 0 ? (
                          Object.keys(groupedWomenResults).map(
                            (month, index) => {
                              return (
                                <>
                                  <div key={month}>
                                    <h2 className="text-lg font-extrabold tracking-tight text-gray-400 text-center mt-20">
                                      {month}
                                    </h2>
                                    {groupedWomenResults[month].map(
                                      (result) => {
                                        return (
                                          <div key={result.id} className="mb-6">
                                            <FixtureResultCard
                                              result={result}
                                            />
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                </>
                              );
                            }
                          )
                        ) : (
                          <TabNoData />
                        )}
                      </div>
                    </Tab.Panel>
                  </Tab.Panels>
                </Tab.Group>
              ) : (
                <TabNoData />
              )}
            </Tab.Panel> */}

            {/* ACADEMY FIXTURES AND RESULTS */}
            {/* <Tab.Panel className="mt-5">
              {academyFixtures.length !== 0 || academyResults.length !== 0 ? (
                <Tab.Group>
                  <Tab.List className="-mb-px flex justify-center items-center space-x-8 overflow-x-auto">
                    <Tab
                      className={({ selected }) =>
                        classNames(
                          "whitespace-nowrap px-3 py-2 font-medium text-sm rounded-md focus:outline-none mb-6",
                          selected
                            ? "bg-red-100 text-red-700 dark:bg-green-100 dark:text-green-700 active:border-none"
                            : "text-gray-500 hover:text-gray-700"
                        )
                      }
                    >
                      Fixtures
                    </Tab>
                    <Tab
                      className={({ selected }) =>
                        classNames(
                          "whitespace-nowrap px-3 py-2 font-medium text-sm rounded-md focus:outline-none mb-6",
                          selected
                            ? "bg-red-100 text-red-700 dark:bg-green-100 dark:text-green-700 active:border-none"
                            : "text-gray-500 hover:text-gray-700"
                        )
                      }
                    >
                      Results
                    </Tab>
                  </Tab.List>
                  <Tab.Panels>
                    <Tab.Panel>
                      <div className="mb-16">
                        {academyNextMatch ? (
                          <NextMatchBanner fixture={academyNextMatch} />
                        ) : (
                          <></>
                        )}

                        {Object.keys(groupedAcademyFixtures).length !== 0 ? (
                          Object.keys(groupedAcademyFixtures).map(
                            (month, index) => {
                              return (
                                <>
                                  <div key={month}>
                                    <h2 className="text-lg font-extrabold tracking-tight text-gray-400 text-center mt-20">
                                      {month}
                                    </h2>
                                    {groupedAcademyFixtures[month].map(
                                      (fixture) => {
                                        return (
                                          <div
                                            key={fixture.id}
                                            className="mb-6"
                                          >
                                            <FixtureCard
                                              fixture={fixture}
                                              ticketUrl={ticketUrl}
                                            />
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                </>
                              );
                            }
                          )
                        ) : (
                          <TabNoData />
                        )}
                      </div>
                    </Tab.Panel>
                    <Tab.Panel>
                      <div className="mb-16">
                        <>
                          {academyLastMatch ? (
                            <>
                              <LastMatchBanner fixture={academyLastMatch} />
                              <StandingsButton />
                            </>
                          ) : (
                            <></>
                          )}
                        </>

                        {Object.keys(groupedAcademyResults).length !== 0 ? (
                          Object.keys(groupedAcademyResults).map(
                            (month, index) => {
                              return (
                                <>
                                  <div key={month}>
                                    <h2 className="text-lg font-extrabold tracking-tight text-gray-400 text-center mt-20">
                                      {month}
                                    </h2>
                                    {groupedAcademyResults[month].map(
                                      (result) => {
                                        return (
                                          <div key={result.id} className="mb-6">
                                            <FixtureResultCard
                                              result={result}
                                            />
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                </>
                              );
                            }
                          )
                        ) : (
                          <TabNoData />
                        )}
                      </div>
                    </Tab.Panel>
                  </Tab.Panels>
                </Tab.Group>
              ) : (
                <TabNoData />
              )}
            </Tab.Panel> */}
          </Tab.Panels>
        </Tab.Group>
      </div>
    </>
  );
};

export default FixturesAndResults;

export const getStaticProps = async (context) => {
  const token = getApiToken();
  const fixturesAndResults = await apiWrapper.get(kAllFixturesURL, token);

  return {
    props: {
      fixturesAndResults: fixturesAndResults?.data,
    },
    revalidate: ONE_DAY_REFRESH_INTERVAL_SECONDS,
  };
};
